"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledImageCell = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const cell_text_content_constants_1 = require("../partials/cell-text-content.constants");
const table_cell_styles_1 = require("../partials/table-cell.styles");
exports.StyledImageCell = (0, styled_components_1.default)(material_1.TableCell) `
  text-align: center;
  padding: 0;

  p {
    margin: 0;
  }

  &:not(.image--is-not-loaded) {
    line-height: 0;

    img {
      height: 2.5rem;
      width: 2.5rem;
    }

    &.cell--expanded {
      vertical-align: middle;

      img {
        height: 8rem;
        width: 8rem;
      }
    }
  }

  &.image--is-not-loaded {
    vertical-align: top;
    line-height: 20px;
    padding: ${table_cell_styles_1.TEXT_CELL_PADDING};

    img {
      font-size: 0.75rem;
      line-height: 1.2rem;
      color: ${({ theme }) => theme.palette.text.secondary};
      display: -webkit-box;
      white-space: pre-line;
      text-overflow: ellipsis;
      -webkit-line-clamp: ${cell_text_content_constants_1.maxRowsCollapsed};
      -webkit-box-orient: vertical;
      width: 8rem;
      text-align: left;
    }

    &.cell--expanded {
      vertical-align: top;

      img {
        -webkit-line-clamp: ${cell_text_content_constants_1.maxRowsExpanded};
      }
    }
  }

  
`;
